const AuthTypes = ['None', 'API_Key', 'Bearer_Token', 'Basic_Auth'];

export { AuthTypes };
